import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group 1538231752" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M8.00004 7.81879C9.94817 7.81879 11.5274 6.2541 11.5274 4.32395C11.5274 2.3938 9.94817 0.829102 8.00004 0.829102C6.05192 0.829102 4.47266 2.3938 4.47266 4.32395C4.47266 6.2541 6.05192 7.81879 8.00004 7.81879Z",
        stroke: "#AA1E2D",
        "stroke-width": "1.5",
        "stroke-miterlimit": "10"
      }),
      _createElementVNode("path", {
        id: "Vector_2",
        d: "M1 15.1719V12.9524C1 11.3914 2.27718 10.126 3.85276 10.126H12.1472C13.7228 10.126 15 11.3914 15 12.9524V15.1719",
        stroke: "#AA1E2D",
        "stroke-width": "1.5",
        "stroke-miterlimit": "10"
      })
    ], -1)
  ])))
}
export default { render: render }